<template>
  <div class="detail-wrapper">
    <div class='news-detail-page-wrapper' :class="[{ dark: darkClass }]">
      <van-loading v-if="detailLoading" size="20px">加载中...</van-loading>
      <div v-else>
        <h2 class="title">{{ dataItem.title }}</h2>
        <div class="meta">
          <span class="meta-source">{{ dataItem.source }}</span>
          <span class="meta-time">{{ formatNewsItemDate(dataItem.ctime) }}</span>
        </div>
        <div class="show-pdf" v-if="dataItem.pdfUrl">
          <div class="icon">
            <img src="@/assets/images/icon-pdf.png" alt="" />
          </div>
          <span class="pdf-innerSpan">点击查看公告pdf原文</span>
          <span class="pdf-btn" @click="downloadPdf">查看</span>
        </div>
        <template v-if="dataItem.content && dataItem.content.trim()">
          <div class="detail-content" v-dompurify-html="dataItem.content"></div>
          <div v-if="showOpenXlsx" class="show-xlsx-Btn" @click="downloadXlsx">点击查看</div>
        </template>
        <van-empty v-else description="暂无数据" />
        <div class="disclaimer">{{ disclaimer }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { disclaimer } from './utils/article';
import { isDark } from './utils/oemUtils';
import { Loading, Empty } from 'vant';
import { afficheDetail } from '@/api/b2b-news';
export default {
  name: 'afficheDetail',
  components: {
    [Loading.name]: Loading,
    [Empty.name]: Empty,
  },
  computed: {
    // 判断是否是黑夜皮肤
    darkClass() {
      return isDark() ? 'dark' : null;
    },
    showOpenXlsx() {
      const arr = this.dataItem?.jumpUrl?.source?.split('.');
      return arr[arr.length - 1] === 'xlsx';
    }
  },
  data() {
    return {
      detailLoading: true,
      dataItem: {},
      disclaimer,
    };
  },
  async mounted() {
    await this.getDetail();
  },
  methods: {
    // 展示pdf
    downloadPdf() {
      this.$app.downloadFile({
        filetype: 'PDF',
        url: this.dataItem.pdfUrl,
        title: this.dataItem.title,
      });
    },
    getDetail() {
      const { id, accessKey } = this.$route.query;
      afficheDetail({
        type: 'sn',
        id,
        accessKey
      }).then(res => {
        res.data && (this.dataItem = res.data);
      }).finally(() => {
        this.detailLoading = false;
      });
    },
    /**
     * @description 时间类型
     */
    formatNewsItemDate(val) {
      return !val ? '' : dayjs(val).format('YYYY-MM-DD');
    },
    // 客户端方法打开xlsx文件
    downloadXlsx() {
      this.$app.downloadFile({
        filetype: 'XLSX',
        url: this.dataItem.jumpUrl.source,
        title: this.dataItem.title,
      });
    }
  },
};
</script>
<style lang="less" scoped>
.detail-wrapper {
  height: 100vh;
}

.news-detail-page-wrapper {
  padding: 15px;
  background-color: #fff;
  color: #333;
  font-size: 16px;
  line-height: 24px;
  min-height: calc(100% - 30px);

  .title {
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    word-break: break-all;
  }

  .meta {
    display: flex;
    margin-top: 15px;
    color: #a3a3a3;
    font-size: 14px;

    &-source {
      margin-right: 10px
    }
  }

  .show-pdf {
    display: flex;
    width: 100%;
    height: 40px;
    line-height: 40px;
    margin-top: 20px;
    padding: 0 12px;
    background-color: #f5f6f6;
    border-radius: 4px;
    box-sizing: border-box;

    .icon {
      margin-top: 6px;
      width: 22px;
      height: 22px;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .pdf-innerSpan {
      margin-left: 10px
    }

    .pdf-btn {
      color: #4e88ff;
      margin-left: auto;
      text-align: right;
    }
  }

  .detail-content {
    margin-top: 15px;
    word-break: break-all;
  }

  .show-xlsx-Btn {
    width: 200px;
    margin: 20px auto;
    padding: 10px 0;
    text-align: center;
    color: #fff;
    background: #6094F1;

    // display: inline-block;
    // background: #6094F1;
    // color: #fff;
    // padding: 10px 61.1px;
    // text-decoration: none;
    // margin: 14px auto;
    // font-size: 14px;
  }

  .disclaimer {
    margin-top: 30px;
    line-height: 22px;
    font-size: 12px;
    color: #a3a3a3;
  }
}

.van-loading {
  height: 100vh;
  line-height: 100px;
  text-align: center;
}

.dark {
  background-color: #121212;
  color: #D2D2D2;

  .title {
    color: #D2D2D2;
  }

  .meta {
    color: #A9A9A9;
  }

  .show-pdf {
    background-color: #252525;

    .pdf-btn {
      color: #497DE6;
    }
  }

  .disclaimer {
    color: #8E8E8E;
  }

  .van-loading {
    background-color: #121212;
  }
}

.outActivity.news-detail-page-wrapper {
  min-height: calc(100% - 30px - 56px);
  padding-top: 71px;
}
</style>
<style lang="less">
.news-detail-page-wrapper {
  .detail-content {
    p {
      margin-top: 10px;
      word-break: break-word;
      // text-indent: 2em;
      // margin: 10px 0;
    }

    img {
      width: 100% !important
    }

    a {
      display: none;
    }

    .brokers_hidden {
      display: none
    }
  }
}
</style>
